import React, { useState } from 'react';
import { useWalletStore } from '@/src/store/global';
import { saveXShare } from '@/src/lib/incentivized/client/helper';

interface XShareButtonProps {
    className?: string;
    style?: React.CSSProperties;
    txHash?: string;
}

const XShareButton: React.FC<XShareButtonProps> = ({ className, style, txHash }) => {
    const walletStore = useWalletStore();
    const [isSharing, setIsSharing] = useState(false);
    const [hasShared, setHasShared] = useState(false);

    const handleShare = async () => {
        const userWalletAddress = walletStore.info?.address

        if (!userWalletAddress || !txHash) {
            console.error('Missing wallet address or tx hash');
            return;
        }

        const text = `I'm in! 🎯
Just joined the @MAYZProtocol Incentives Campaign — a fun and easy way to support Cardano’s DeFi ecosystem 💪
Complete a few simple tasks, earn $gMAYZ, and help grow decentralized finance on Cardano 🚀`;
 const urlLInk = `http://medium.com/@MAYZ.io/mayz-index-fund-campaign-ad867101664d`
        const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(
            urlLInk
        )}`;
        const popup =window.open(twitterUrl, '_blank');

        if (!popup) {
            console.warn('Popup blocked - please allow popups to share on X');
            return;
        }

        // Guardar en la base de datos
        setIsSharing(true);

        try {
            const result = await saveXShare(userWalletAddress, txHash);

            if (result.success) {
                console.log('X share saved successfully');
                setHasShared(true);
            } else {
                console.error('Failed to save X share:', result.error);

                // Si ya fue compartido, no es un error crítico
                if (result.error === 'Share already recorded for this transaction') {
                    setHasShared(true);
                }
            }
        } catch (error) {
            console.error('Error saving share:', error);
        } finally {
            setIsSharing(false);
        }
    };

    const getButtonText = () => {
        if (hasShared) return '✓ Shared on X';
        if (isSharing) return 'Saving...';
        return 'Share on X';
    };

    const getButtonStyle = () => ({
        backgroundColor: hasShared ? '#1DA1F2' : '#000',
        color: '#fff',
        padding: '10px 20px',
        borderRadius: '15px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: hasShared ? 'default' : 'pointer',
        opacity: isSharing ? 0.7 : 1,
        transition: 'all 0.2s ease',
        ...style,
    });

    return (
        <button className={className} style={getButtonStyle()} onClick={handleShare} disabled={isSharing || hasShared}>
            {getButtonText()}
        </button>
    );
};

export default XShareButton;
